import type { BillingCurrency } from '@pomoshnik/shared';

/**
 * Чистые презентационные хелперы биллинга для Экрана 2.11.3 — Block 11 Phase 11.C
 * (ADR-0093, container-presenter ADR-0005). Здесь — никакого React, только
 * форматирование денег (суммы приходят от бэка, P-003 — клиент их не считает).
 *
 * Вынесено из `SubscriptionScreenView.tsx` отдельным модулем: View-файлы по
 * конвенции репо экспортируют только компонент + типы (react-refresh), а это —
 * pure-функция.
 */

const CURRENCY_SUFFIX: Record<BillingCurrency, string> = {
  KZT: '₸',
  RUB: '₽',
  UZS: 'сум',
};

/** Группировка тысяч пробелом (детерминированно, без `toLocaleString` — стабильно в тестах). */
function groupThousands(n: number): string {
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/** Деньги — целое в основной единице + суффикс валюты (суммы от бэка, P-003). */
export function formatMoney(amount: number, currency: BillingCurrency): string {
  return `${groupThousands(amount)} ${CURRENCY_SUFFIX[currency]}`;
}
